import { EMPTINESS_SIGN } from 'rp-react-table';

export const placesSort = key => (a, b) => {
    if (a[key] === 0) {
        return 1;
    }
    if (b[key] === 0) {
        return -1;
    }
    return a[key] - b[key];
};

export const zeroToDash = key => rowData => rowData[key] || EMPTINESS_SIGN;



// WEBPACK FOOTER //
// ./src/js/utils/number.js